import React from 'react'

interface LabelProps {
    icon?:React.ReactNode;
    isIconLeft?:boolean;
    text: string;
    htmlFor?: string;
    className?: string;
    required?: boolean;
}

const Label: React.FC<LabelProps> = ({
     text, 
     htmlFor, 
     className = '', 
     required = false ,
     isIconLeft= false,
     icon
    }) => {
    return (
        <label htmlFor={htmlFor} className={className}>
            {icon && isIconLeft && icon}
            {isIconLeft ? " " + text : text + " "}
            {icon && !isIconLeft && icon}
            {required && <span className="text-danger">*</span>}
        </label>
    );
}

export default Label;